// extracted by mini-css-extract-plugin
module.exports = {"small":"Spacer_small__1NC-4","medium":"Spacer_medium__3zcDG","large":"Spacer_large__1kk2i","row":"Spacer_row__1HhGr","column":"Spacer_column__3bd9X"};